import { z } from "zod";
import { TextAlignSchema } from "../../../../../zod/shared-schemas.mjs";
const AbImageItemShema = z.object({
  src: z.string().optional().nullable(),
  alt: z.string().optional().nullable(),
  width: z.number().optional().nullable(),
  height: z.number().optional().nullable()
});
const AbImageSchema = z.object({
  src: z.string().optional().nullable(),
  alt: z.string().optional().nullable(),
  desktop: AbImageItemShema.optional().nullable(),
  tablet: AbImageItemShema.optional().nullable(),
  mobile: AbImageItemShema.optional().nullable()
});
const FormSectionTextImageSchema = z.object({
  id: z.string().optional().nullable(),
  title: z.string().optional().nullable(),
  description: z.string().optional().nullable(),
  textAlign: TextAlignSchema.optional().nullable(),
  formId: z.string(),
  successMessage: z.object({
    title: z.string(),
    description: z.string(),
    buttonText: z.string()
  }).optional().nullable(),
  hideFormTitle: z.boolean().optional().nullable(),
  hideFormDescription: z.boolean().optional().nullable(),
  background: z.boolean().optional().nullable(),
  image: AbImageSchema.optional().nullable()
});
export default FormSectionTextImageSchema;
